import React, { useEffect, useState } from "react";
import { CustomDropDown } from "../../../../shared/components/AllInputs";
import { OrderCard } from "../../../../shared/components/CustomCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../../../../store/slices/ordersSlice";
import { getImageUrl } from "../../../../utils/commonFunctions";
import moment from "moment/moment";
import { useParams } from "react-router-dom";

export default function MyOrder() {
  const dispatch = useDispatch();
  const { id } = useParams()
  const { orders } = useSelector((state) => state.order);
  const [selectedFilter, setSelectedFilter] = useState("");

  useEffect(() => {
    dispatch(fetchOrders({ status: RouteStatus[id] }));
  }, [dispatch]);

  const events = [
    { status: "Pending", value: "PENDING" },
    { status: "Order placed", value: "CONFIRMED" },
    { status: "Expert assigned", value: "EXPERT_ASSIGNED" },
    { status: "Processing", value: "PROCESSING" },
    { status: "Rework", value: "REWORK" },
    { status: "Completed", value: "COMPLETED" },
  ];

  const filterOptions = [
    { name: "Completed", value: "COMPLETED" },
    { name: "Active", value: "ACTIVE" },
    { name: "In Draft", value: "draft" },
  ];

  const RouteStatus = {
    "awaiting-payment": "UNPAID",
    "getting-ready": "ACTIVE",
    "order-delivered": "COMPLETED",
    "rework-requested": "REWORK",
    "in-draft": "DRFAT",
  }

  const prepareTimeline = (order) => {
    const currentStatusIndex = events.findIndex(
      (event) => event.value === order.status
    );

    return events
      .map((event, index) => ({
        ...event,
        active: index <= currentStatusIndex,
      }))
      .filter((event) => event.value !== "REWORK" || order.isRework);
  };

  const handleFilter = ({ name, value }) => {
    const filterData = {};
    if (value) {
      setSelectedFilter(value);
      if (value === "draft") filterData.isDraft = true;
      else filterData.status = value;
      dispatch(fetchOrders({ status: RouteStatus[id], filterData }));
    } else {
      setSelectedFilter("");
      dispatch(fetchOrders({ status: RouteStatus[id] }));
    }
  };

  return (
    <div className="container">
      <div className="md:flex justify-content-between gap-3">
        <h2 className="text-3xl">My Orders</h2>
        <div className="flex align-items-center gap-3 w-full lg:w-5 justify-content-between lg:justify-content-end">
          <label htmlFor="" className="font-medium">
            Filter by
          </label>
          <CustomDropDown
            extraClassName="w-4"
            dropDownClassName="border-none bg-gray-200 w-full"
            name="filter"
            value={selectedFilter}
            options={filterOptions}
            onChange={handleFilter}
            showClear={true}
            hideFloatlabel
          />
        </div>
      </div>
      <hr />

      {orders?.length > 0 ? (
        orders.map((order, index) => {
          const timeline = prepareTimeline(order);
          return (
            <OrderCard
              key={index}
              orderid={"#" + order?.id}
              to={"details/" + order._id}
              src={getImageUrl(order?.images[0]?.beforeImage)}
              type={order?.service?.serviceName}
              placedOn={moment(order?.time).format("ddd, MMM Do YYYY")}
              total={"$" + order?.totalPrice}
              projectname={order?.projectName}
              quantity={order?.quantity}
              timeline={timeline}
              status={order?.status}
              rework={order?.isRework}
            />
          );
        })
      ) : (
        <div className="flex flex-column align-items-center justify-content-center py-8">
          <h3 className="text-2xl font-medium text-gray-600 mb-2">
            You haven't placed any orders yet
          </h3>
          <p className="text-gray-500 text-center mb-4">
            When you place orders, they'll appear here.
          </p>
        </div>
      )}
    </div>
  );
}
